import {Pager} from "../../domain/model/common";

// client entry list
interface IGetAllEntriesByClientRequest {
    projectId?: string;
}
class GetAllEntriesByClientRequest implements IGetAllEntriesByClientRequest {
    public projectId: string;
}

// customer entry list
interface IGetEntryProjectsByCustomerRequest {
    pager: Pager;
}
class GetEntryProjectsByCustomerRequest implements IGetEntryProjectsByCustomerRequest {
    public pager: Pager;
}

export {
    // client entry list
    GetAllEntriesByClientRequest,
    // customer entry list
    GetEntryProjectsByCustomerRequest,
}




// WEBPACK FOOTER //
// ./src/presentation/request/entry_request.ts